import { useState, useEffect } from "react";
import { UserState } from "./use-user-state.types";
import { DEFAULT_USER_STATE, STATE_SUBJECT } from "./use-user-state.constants";

export function useUserState() {
  const [userState, setUserState] = useState<UserState>(DEFAULT_USER_STATE);

  useEffect(() => {
    const handleUserStateCallback = (event: { channel: string, payload: UserState | undefined }) => {
      setUserState({ ...DEFAULT_USER_STATE, ...event.payload });
    };
    let sub: { unsubscribe: () => void };
    void (async () => {
      sub = await window.eventBus.subscribe(STATE_SUBJECT, true, handleUserStateCallback);
    })();
    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, []);

  return userState;
}
